import React from "react";

import { ReactComponent as EraserIcon } from "src/images/eraser.svg";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { Button } from "src/app/components/Button/Button";

export default function ClearSelectedButton({ handleClearSelected }) {
  return (
    <Button
      onClick={handleClearSelected}
      size="medium"
      variant="white"
      data-qa="clear-selected-button"
    >
      <EraserIcon />
      <IDHFormattedMessage id="front_clear" defaultMessage="Clear" />
    </Button>
  );
}
